import { Modal, Form, Button } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import DatePiker from "../../datepiker/datePiker";
import useAxios from "../../../services/useAxios";
import AuthenticationContext from "../../../Authentication/AuthenticationContext.ts";
import {
  showSwalQuestion,
  showSwalSuccess,
  showSwalError,
} from "../../../utils/swal";
import Select from "react-select";
import { CustomInput, ReactSelect } from "../../kits/Inputs/Inputs";

export default function AddClue({
  show,
  setShow,
  customer,
  campaign,
  step,
  setStep,
}) {
  const { userInfo } = useContext(AuthenticationContext);

  const handleClose = () => {
    setShow(false);
    setCustomerValue("");
    setCampaignValue("");
    setStepValue("");
  };
  const { execute: addLeadStep } = useAxios("api/chat_add_lead_step_linkd");

  const { execute: get_step } = useAxios("api2/Find_Step");

  const [customerValue, setCustomerValue] = useState({ value: "", label: "" });
  const [campaignValue, setCampaignValue] = useState({ value: "", label: "" });
  const [stepValue, setStepValue] = useState({ value: "", label: "" });

  useEffect(() => {
    setStep([]);
    setStepValue({ value: "", label: "" });
    setCustomerValue({ value: "", label: "" });
    setCampaignValue({ value: "", label: "" });
  }, []);

  const add = () => {
    if (customerValue != "" && campaignValue != "" && stepValue != "") {
      addLeadStep({
        admin_id: userInfo.id,
        customer_id: customerValue.value,
        step_id: stepValue.value,
        campaign_id: campaignValue.value,
      }).then((data) => {
        if (data.status == 1) {
          showSwalSuccess("با موفقیت ثبت شد");
          setShow(false);
        } else {
          showSwalError("لطفا دوباره امتحان کنید");
        }
      });
    } else {
      showSwalError("لطفا همه مقادیر را وارد کنید");
    }
  };
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>افزودن سرنخ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ReactSelect
            itemsList={customer}
            inputValue={customerValue}
            onChangeFunc={(e) => {
              setCustomerValue(e);
            }}
            id="admin"
            title="مشتری"
            inputSize="lg"
            type="text"
            style={{ marginTop: "15px" }}
          />
          <ReactSelect
            itemsList={campaign}
            inputValue={campaignValue}
            onChangeFunc={(e) => {
              get_step({
                conditions: `campaign_id/=/${e.value}`,
              }).then((data) => {
                let array = [];
                data.map((item) => {
                  array.push({
                    value: item.id,
                    label: item.title,
                  });
                });
                setStep(array);
              });
              setCampaignValue(e);
            }}
            id="admin"
            title="کمپین"
            inputSize="lg"
            type="text"
            style={{ marginTop: "15px" }}
          />
          <small className="text-danger">
            * ابتدا کمپین را انتخاب کنید و بعد step
          </small>
          <ReactSelect
            itemsList={step}
            inputValue={stepValue}
            onChangeFunc={(e) => {
              setStepValue(e);
            }}
            id="admin"
            title="step"
            inputSize="lg"
            type="text"
            style={{ marginTop: "15px" }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            لغو
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              add();
            }}
          >
            ذخیره
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
